import { cn } from '@wwe-portal/ui/lib/lib';
import { ReactNode } from 'react';

export const SectionLayout = ({
  children,
  title,
  subtitle,
  className,
}: {
  children: React.ReactNode;
  title: ReactNode;
  subtitle: React.ReactNode;
  className?: string;
}) => {
  return (
    <div className={cn('bg-back400 overflow-hidden rounded-xl', className)}>
      <div className="flex items-center justify-between p-5 md:px-[30px]">
        <h5 className="text-text300 text-base font-medium md:text-xl 2xl:text-xl">
          {title}
        </h5>

        <div className="text-text600 text-xs md:text-sm">{subtitle}</div>
      </div>
      <hr className="border-text800 border-t" />
      <div className="py-5 md:p-[30px]">{children}</div>
    </div>
  );
};
